import styled from '@emotion/styled'
import {
  IconButton as MuiIconButton,
  Menu,
  MenuItem,
  Tooltip,
} from '@mui/material'
import { spacing } from '@mui/system'
import React from 'react'
import { useNavigate } from 'react-router-dom'

import useAuth from '@/hooks/useAuth'
import useLoggedInUser from '@/hooks/useLoggedInUser'
import useT from '@/i18n/useT'

import { UserAvatar } from '../users/UserAvatar'

const IconButton = styled(MuiIconButton)`
  ${spacing};

  &:hover {
    background-color: transparent;
  }
`

function NavbarUserDropdown() {
  const [anchorMenu, setAnchorMenu] = React.useState<any>(null)
  const navigate = useNavigate()
  const { signOut } = useAuth()
  const { user } = useLoggedInUser('cache-first')
  const { t } = useT()

  const toggleMenu = (event: React.SyntheticEvent) => {
    setAnchorMenu(event.currentTarget)
  }

  const closeMenu = () => {
    setAnchorMenu(null)
  }

  const handleSignOut = async () => {
    await signOut()
    navigate('/auth/sign-in')
  }

  return (
    <>
      <Tooltip title={t('navbarUserDropdown.account')}>
        <IconButton
          aria-owns={anchorMenu ? 'menu-appbar' : undefined}
          aria-haspopup="true"
          onClick={toggleMenu}
          color="inherit"
        >
          {!!user && (
            <UserAvatar firstName={user.firstName} lastName={user.lastName} />
          )}
        </IconButton>
      </Tooltip>
      <Menu
        id="menu-appbar"
        anchorEl={anchorMenu}
        open={Boolean(anchorMenu)}
        onClose={closeMenu}
      >
        <MenuItem onClick={handleSignOut}>
          {t('navbarUserDropdown.signOut')}
        </MenuItem>
      </Menu>
    </>
  )
}

export default NavbarUserDropdown
